import { render } from "./PackageStatusCard.vue?vue&type=template&id=7ee1716e&scoped=true"
import script from "./PackageStatusCard.vue?vue&type=script&lang=js"
export * from "./PackageStatusCard.vue?vue&type=script&lang=js"

import "./PackageStatusCard.vue?vue&type=style&index=0&id=7ee1716e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee1716e"]])

export default __exports__